/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Box, Button, TextField } from '@mui/material';
import { useCallback /*, useRef*/, useState } from 'react';
import useAbortController from '../../common/hooks/useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';
import Styles from '../../css/BulkDisbursementPage.module.css';
import axiosCall from '../../services/axios';
import EnvelopeWithBox from '../EnvelopeWithBox';

const BulkDisbursementForm = () => {
  enum FileTypes {
    MISC = 'Misc Disbursements',
    INS = 'Insurance Update/Disburse',
  }

  const { token } = useAuthContext();
  const { get } = useAbortController();
  const FormData = require('form-data');

  const [response, setResponse] = useState(null);
  const [fileType, setFileType] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setFileType('');
    setResponse('');
  };
  const handleFileTypeChange = (event) => {
    setFileType(event.target.value);
    setResponse('');
  };

  const addDisbursements = useCallback(
    async (e) => {
      if (!token) return;
      const config = get();
      var bodyFormData = new FormData();
      const blobdata = "{ FileType : '" + fileType + "' }";
      bodyFormData.append('bulkDisburseFile', selectedFile);
      bodyFormData.append('metadata', new Blob([blobdata], { type: 'application/json' }));

      const headers = {
        'Session-Token': token,
        Accept: 'application/json',
      };
      try {
        setResponse(
          await axiosCall(
            {
              url: `live/servicing/payments/bulk/misc-disbursements`,
              method: 'POST',
              data: bodyFormData,
            },
            config,
            headers,
          ),
        );
        // setSelectedFile("");
        setFileType('');
        return true;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    [get, fileType, FormData, selectedFile, token],
  );

  return (
    <EnvelopeWithBox blockName='Bulk Disbursement'>
      <div className={Styles.page}>
        <Box mt={1}>
          <Button variant='contained' component='label' className={Styles.paddedButton}>
            Choose File
            <input type='file' hidden onChange={handleFileChange} />
          </Button>
          {selectedFile && selectedFile.name}
        </Box>
        <Box mt={1}>
          File Type:
          <select value={fileType} className={Styles.page} onChange={handleFileTypeChange}>
            <option value=''> -- select an option -- </option>
            {Object.values(FileTypes).map((value: string, index: number) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </Box>
        {selectedFile && (
          <Box mt={1}>
            <Button variant='contained' type='submit' onClick={addDisbursements}>
              Submit
            </Button>
          </Box>
        )}
        {response && (
          <Box mt={1}>
            <TextField className={Styles.page} label='Response: ' value={response.result[0]} />
          </Box>
        )}
      </div>
    </EnvelopeWithBox>
  );
};

export default BulkDisbursementForm;
